// extracted by mini-css-extract-plugin
export var active = "_fa-7";
export var blink = "_fa-8";
export var dropDownSelector = "_fa-4";
export var dropDownWrapper = "_fa-3";
export var fakeCursor = "_fa-6";
export var fontSizeButton = "_fa-9";
export var formQuillEditor = "_fa-0";
export var pressed = "_fa-a";
export var qlBlank = "_fa-1";
export var textFormattingToolbar = "_fa-2";
export var textToolbarOption = "_fa-5";